import { Flex, Text } from "@gravity-ui/uikit";
import cn from "classnames";

import { VariantTreeDto } from "../../../../VariantTreeDto";
import { ProductPriceDetailsButton } from "./components";
import { ProductPriceDetailsSkeleton } from "./ProductPriceDetailsSkeleton";
import css from "./ProductPriceDetailsSkeleton.module.scss";

interface ProductPriceDetailsProps {
  isLoading: boolean;
  variants?: VariantTreeDto | null;
  isBlur: boolean;
  selected: Record<string, string>;
  onChange: (next: Record<string, string>) => void;
  valuesWithoutStore?: Record<string, string[]>;
}

export const ProductPriceDetails = ({
  isLoading,
  variants,
  isBlur,
  selected,
  onChange,
  valuesWithoutStore,
}: ProductPriceDetailsProps) => {
  if (isLoading) return <ProductPriceDetailsSkeleton />;
  if (!variants) return null;

  const { attributes } = variants;

  return (
    <Flex direction="column" gap={2}>
      {Object.entries(attributes).map(([attributeName, values]) => (
        <Flex key={attributeName} direction="column" gap={1}>
          <Text
            variant="subheader-2"
            color="secondary"
            className={cn({ [css.blur]: isBlur })}
          >
            {attributeName}
          </Text>

          <Flex gap={2} wrap>
            {values.map((value) => (
              <div key={value}>
                <ProductPriceDetailsButton
                  isBlur={isBlur}
                  isUnavailable={valuesWithoutStore?.[attributeName]?.includes(
                    value,
                  )}
                  value={value}
                  selected={selected}
                  attributeName={attributeName}
                  onChange={onChange}
                />
              </div>
            ))}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};
